<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.bookClub')"
    :batch-actions="batchActions"
    resource="book_clubs"
  >
    <template slot="action">
      <bean-import-button
        can='book_clubs.create'
        buttonText="导入"
        tooltipText="导入读书会"
        url="/book_clubs/import"
        loadingToast="导入中...请不要刷新页面"
        :excelTemplateDownloadLink="importExcelTemplateDownloadLink"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/book_clubs.js';
import _ from 'lodash';

@Component
export default class BookClubs extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'keyword'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'number',
      'title',
      'note',
      'cover',
      'start_at',
      'end_at',
      'lecturer',
      'address',
      'likes_count',
      'views_count',
      'stars_count',
      'shares_count',
      'comments_count',
      'share_desc',
      type === 'show' && 'content_type',
      type === 'show' && { key: 'content', renderCell: { component: 'html' }  },
      type === 'show' && { key: 'markdown_content', renderCell: { component: 'richText', props: { type: 'markdown' } }  },
      type === 'show' && 'images',
      type === 'show' && 'related_book_lists',
      'published_at',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'number',
      'title',
      'note',
      'start_at',
      'end_at',
      'lecturer',
      'address',
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 691x370`,
          props: {
            cropper: {
              width: 691,
              height: 295
            }
          }
        }
      },
      {
        key: 'share_desc',
        renderCell: {
          hint: this.$t('hint.shareDescLengthHint'),
        }
      },
      'content_type',
      {
        key: 'content',
        renderCell: {
          component: 'editor'
        }
      },
      {
        key: 'markdown_content',
        renderCell: {
          component: 'markdownEditor'
        }
      },
      {
        key: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x320`,
          props: {
            limit: 9,
            cropper: {
              width: 750,
              height: 320
            }
          }
        }
      },
      'related_book_list_ids',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handlePublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_time_current`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }
    const handleUnpublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_nil`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'book_clubs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '报名',
          to: { name: 'apply_records.index', query: { target_id_eq: row.id } }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '查看心得',
          to: { name: 'commments.index', params: { commentType: 'BookClub', id: row.id } },
          can: 'experience_comments.read'
        }
      },
      !row.published_at &&  {
        component: 'confirmButton',
        props: {
          label: this.$t('post.publish'),
          type: 'primary',
          can: 'book_clubs.update'
        },
        on: {
          confirm: () => handlePublish(row.id)
        }
      },
      row.published_at &&  {
        component: 'confirmButton',
        props: {
          label: this.$t('post.unpublish'),
          type: 'primary',
          can: 'book_clubs.update'
        },
        on: {
          confirm: () => handleUnpublish(row.id)
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'book_clubs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }

  get importExcelTemplateDownloadLink() {
    const baseUrl = process.env.BASE_URL;
    const fileName = '导入读书会';
    const url = baseUrl.endsWith('/') ? `${fileName}.xlsx` : `/${fileName}.xlsx`
    return baseUrl + url;
  }
}

export const route = [
  {
    path: '/book_clubs',
    name: 'book_clubs.index',
    component: BookClubs,
    props: {
      type: 'index',
    }
  },
  {
    path: '/book_clubs/new',
    name: 'book_clubs.new',
    component: BookClubs,
    props: {
      type: 'new',
    }
  },
  {
    path: '/book_clubs/:id',
    name: 'book_clubs.show',
    component: BookClubs,
    props: {
      type: 'show',
    }
  },
  {
    path: '/book_clubs/:id/edit',
    name: 'book_clubs.edit',
    component: BookClubs,
    props: {
      type: 'edit'
    }
  }
]
</script>
